import {LoginForm} from '@/modules/auth/login/components'
import {Box, Container, Flex, Text} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import * as z from 'zod'

const loginSearchSchema = z.object({
  location: z.string().optional(),
})

export const Route = createFileRoute('/auth/login')({
  component: LoginPage,
  validateSearch: loginSearchSchema,
})

function LoginPage() {
  const {t} = useTranslate('auth')

  return (
    <Container maxWidth="22rem" padding="0">
      <Flex flexDirection="column" gapY="1.5rem">
        <Box>
          <Text as="h1" fontSize="2xl" fontWeight="bold" color="fg" fontFamily="heading">
            {t('page_title')}
          </Text>
          <Text as="h2" fontSize="md" color="fg.muted">
            {t('page_desc')}
          </Text>
        </Box>

        <LoginForm />

        <Text fontSize="sm" color="fg.subtle">
          {t('pass_reset_info')}
        </Text>
      </Flex>
    </Container>
  )
}
